import React from 'react';
import { usePanelNavigation } from "./vmSlidingPanel";
import { useAuth } from './vmAuthenticate';

import note_C from '../sounds/note_C_gain.mp3';
import note_Ef from '../sounds/note_Ef_gain.mp3';
import note_F from '../sounds/note_F_gain.mp3';
import note_G from '../sounds/note_G_gain.mp3';
import note_Bf from '../sounds/note_Bf_gain.mp3';

export const VMVotingButtons = ({ 
  currentVote,
  onVote,
  isSubmitting = false,
  playSound = null,
  size = 'normal', // 'small', 'normal', 'large'
  showLabels = true,
  disabled = false,
  className = ''
}) => {
  const { pushPanel } = usePanelNavigation();
  const { refreshVoteCount } = usePanelNavigation();
  const { user } = useAuth();

  const getButtonClass = (buttonValue, currentVote) => {
    if (buttonValue === currentVote) {
      if (buttonValue > 0) return `vm-vote-button-up-${buttonValue}`;
      if (buttonValue < 0) return `vm-vote-button-down-${Math.abs(buttonValue)}`;
      return 'vm-vote-button-zero';
    }
    return 'vm-vote-button-default';
  };

  const handleVoteClick = async (value) => {
    if (isSubmitting || disabled) return;
    
    // Play sound if provided
    if (playSound) {
      try {
        await playSound(value);
      } catch (error) {
        console.log('Sound playback failed:', error);
      }
    }

    await onVote(value);
    if (user?.userId) {
      setTimeout(async () => {
        await refreshVoteCount();
      }, 500);
    }
  };

  const containerClasses = `vm-proposal-vote-button-container ${className}`.trim();
  const buttonSizeClass = `vm-vote-button-${size}`;

  return (
    <div className={containerClasses}>
      {[-2, -1, 0, 1, 2].map(value => (
        <button
          key={value}
          onClick={() => handleVoteClick(value)}
          className={`${getButtonClass(value, currentVote)} ${buttonSizeClass}`}
          disabled={isSubmitting || disabled}
        >
          {showLabels ? value : ''}
        </button>
      ))}
      <button onClick={() => pushPanel(<VMTonesPanel />)}>🎵</button>
    </div>
  );
};

const VMTonesPanel = ({ changeSection }) => {
  const note_C_sound = new Audio(note_C);
  const note_Ef_sound = new Audio(note_Ef);
  const note_F_sound = new Audio(note_F);
  const note_G_sound = new Audio(note_G);
  const note_Bf_sound = new Audio(note_Bf);

  const playSound = (sound) => {
    sound.currentTime = 0;
    sound.play().catch(error => {
      console.log('Sound playback failed:', error);
    });
  };

  return (
    <div className="vm-section">
      <div className="vm-section-sub-header">
        <b>Voting Tones</b>
      </div>
      <div className="vm-section-sub-section">
        <p>
          In the spirit of "why make things boring, when they could be fun?"", we've given the five voting buttons musical values.
          The default set are a C Minor chord. Test the sounds below:
        </p>
        <div className="flex justify-center gap-6 mt-4">
          <button
            onClick={() => playSound(note_C_sound)}
            className="vm-vote-button-down-2 vm-vote-button-normal"
          >C</button>
          <button
            onClick={() => playSound(note_Ef_sound)}
            className="vm-vote-button-down-1 vm-vote-button-normal"
          >E♭</button>
          <button
            onClick={() => playSound(note_F_sound)}
            className="vm-vote-button-zero vm-vote-button-normal"
          >F</button>
          <button
            onClick={() => playSound(note_G_sound)}
            className="vm-vote-button-up-1 vm-vote-button-normal"
          >G</button>
          <button
            onClick={() => playSound(note_Bf_sound)}
            className="vm-vote-button-up-2 vm-vote-button-normal"
          >B♭</button>
        </div>
        <p>
          In the future this page will be expanded to allow you to customize the musical tones assigned to your vote buttons.
        </p>
      </div>
    </div>
  );
};
